export default class Settings {
    public settings = {
        host: window.location.hostname.indexOf('localhost') < 0 ? 'https://api.prospe.atpsolutions.pl' : 'http://stg.api.prospe.atpsolutions.ovh'
    };
}
